export const products = [
  {
    id: 1,
    name: "Dooars Tea",
    description: "Strong flavor tea with rich aroma and bright liquor, sourced from the fertile Dooars region of West Bengal.",
    origin: "Dooars, West Bengal",
    moq: "25 KG",
    image: "https://public.readdy.ai/ai/img_res/8f22434320dd3aab8f84fb8624320352.jpg"
  },
  {
    id: 2,
    name: "Assam Tea",
    description: "Premium tea known for its bold malty taste and high global demand, harvested from the iconic Assam Valley gardens.",
    origin: "Assam, India",
    moq: "25 KG",
    image: "https://readdy.ai/api/search-image?query=Assam%20tea%20estate%20with%20rows%20of%20lush%20green%20tea%20bushes%20stretching%20across%20rolling%20hills%20under%20golden%20morning%20sunlight%2C%20freshly%20plucked%20orthodox%20black%20tea%20leaves%20in%20a%20woven%20bamboo%20basket%20placed%20on%20soil%20among%20tea%20plants%2C%20warm%20amber%20sunrise%20light%2C%20rich%20emerald%20green%20landscape%2C%20scenic%20India%20northeast%20panorama%2C%20cinematic%20depth%20of%20field&width=600&height=450&seq=pe002new&orientation=landscape"
  },
  {
    id: 3,
    name: "Lakadong Turmeric",
    description: "High curcumin turmeric (6–9%) with strong medicinal value, sourced exclusively from the pristine Lakadong region.",
    origin: "Meghalaya, India",
    moq: "25 KG",
    image: "https://readdy.ai/api/search-image?query=Vibrant%20golden%20yellow%20Lakadong%20turmeric%20root%20and%20powder%20arranged%20on%20white%20marble%20surface%2C%20bright%20yellow%20turmeric%20pieces%20and%20fine%20powder%20with%20mortar%20and%20pestle%2C%20fresh%20organic%20spice%20with%20brilliant%20color%2C%20elegant%20flat%20lay%2C%20professional%20food%20photography%2C%20natural%20sunlight%2C%20rich%20golden%20tones&width=600&height=450&seq=pe003&orientation=landscape"
  },
  {
    id: 4,
    name: "White Turmeric",
    description: "Specialty turmeric with unique flavor profile used in food, herbal medicine, and pharmaceutical applications worldwide.",
    origin: "Northeast India",
    moq: "25 KG",
    image: "https://readdy.ai/api/search-image?query=White%20turmeric%20roots%20and%20sliced%20pieces%20on%20clean%20white%20background%20with%20pale%20cream%20turmeric%20powder%20in%20a%20small%20wooden%20bowl%2C%20specialty%20herbal%20spice%20organic%20arrangement%2C%20soft%20natural%20daylight%2C%20minimal%20clean%20food%20photography%20style%2C%20gentle%20shadows%2C%20high%20detail&width=600&height=450&seq=pe004&orientation=landscape"
  },
  {
    id: 5,
    name: "Indian Spices",
    description: "Premium cumin, coriander, dry red chili, turmeric powder and more — export-grade quality from trusted Indian sources.",
    origin: "Across India",
    moq: "25 KG",
    image: "https://readdy.ai/api/search-image?query=Colorful%20premium%20Indian%20spices%20collection%20in%20round%20wooden%20bowls%20on%20dark%20rustic%20wooden%20table%2C%20cumin%20seeds%20coriander%20whole%20dry%20red%20chilies%20turmeric%20powder%20cardamom%2C%20vibrant%20rich%20colors%20red%20orange%20yellow%20brown%2C%20beautiful%20flat%20lay%20arrangement%20top%20view%2C%20natural%20light%20food%20photography%2C%20warm%20rich%20tones%2C%20artisan%20style&width=600&height=450&seq=pe005&orientation=landscape"
  }
];

export const whyChooseUs = [
  {
    icon: "ri-medal-line",
    title: "Premium Quality",
    description: "Stringent quality control at every stage — from sourcing to packaging — ensuring you receive only the best."
  },
  {
    icon: "ri-price-tag-3-line",
    title: "Competitive Pricing",
    description: "Direct sourcing from farmers ensures best-in-market pricing without compromising on product quality."
  },
  {
    icon: "ri-team-line",
    title: "Trusted Network",
    description: "Built on long-term relationships with reliable farmers, suppliers, and logistics partners across India."
  },
  {
    icon: "ri-truck-line",
    title: "Timely Delivery",
    description: "Efficient supply chain management ensures your orders are shipped and delivered on schedule, every time."
  },
  {
    icon: "ri-eye-line",
    title: "Transparent Business",
    description: "Clear communication, honest pricing, and complete documentation from inquiry to final delivery."
  }
];

export const packagingOptions = [
  { icon: "ri-archive-line", title: "PP Bags", description: "Durable polypropylene bags for bulk exports" },
  { icon: "ri-box-3-line", title: "Jute Bags", description: "Eco-friendly natural jute sacking" },
  { icon: "ri-settings-3-line", title: "Custom Packaging", description: "Tailored to your specifications" },
  { icon: "ri-trademark-line", title: "Private Labeling", description: "Your brand, our quality products" },
  { icon: "ri-shield-check-line", title: "Export-Grade", description: "Safe transit certified packing standards" }
];
